"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2023, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const i18next_1 = __importDefault(require("i18next"));
const react_i18next_1 = require("react-i18next");
const moment_1 = __importDefault(require("moment"));
const i18next_browser_languagedetector_1 = __importDefault(require("i18next-browser-languagedetector"));
const project_config_1 = __importDefault(require("chaire-lib-frontend/lib/config/project.config"));
// TODO: importing a whole directory is allowed in javascript but not in typescript, find another way to import only the needed locales anyway.
// eslint-disable-next-line
const resources = require('../../../../locales/');
const detectorOrder = project_config_1.default.detectLanguageFromUrl
    ? ['querystring', 'path', 'cookie', 'localStorage']
    : project_config_1.default.detectLanguage
        ? ['cookie', 'localStorage', 'navigator']
        : ['cookie', 'localStorage'];
i18next_1.default.use(i18next_browser_languagedetector_1.default)
    .use(react_i18next_1.initReactI18next)
    .init({
    detection: {
        // order and from where user language should be detected
        order: detectorOrder,
        lookupFromPathIndex: 0,
        //checkWhitelist: true, // deprecated
        caches: ['localStorage', 'cookie']
    },
    load: 'languageOnly', // no region-specific,
    preload: project_config_1.default.languages,
    supportedLngs: project_config_1.default.languages,
    nonExplicitSupportedLngs: false,
    resources: resources,
    fallbackLng: project_config_1.default.defaultLocale || 'en',
    debug: false,
    interpolation: {
        escapeValue: false // not needed for react!!
    },
    react: {
    //wait: true, // deprecated
    //useSuspense: false
    }
}, (err, _t) => {
    if (err) {
        console.log(err);
    }
});
if (i18next_1.default.language) {
    i18next_1.default.changeLanguage(i18next_1.default.language.split('-')[0]); // force remove region specific
}
if (!i18next_1.default.language || project_config_1.default.languages.indexOf(i18next_1.default.language) <= -1) {
    i18next_1.default.changeLanguage(project_config_1.default.defaultLocale);
}
i18next_1.default.on('languageChanged', (language) => {
    document.documentElement.setAttribute('lang', language);
    moment_1.default.locale(language);
});
exports.default = i18next_1.default;
//# sourceMappingURL=i18n.config.js.map